import React, { useEffect, useState } from "react";
import { matchPath } from "react-router-dom";
import PropTypes from "prop-types";
import { List, Typography } from "@material-ui/core";
import useRouter from "../../../../utils/useRouter";
import SidebarMenuListItem from "./SidebarMenuListItem";
import authentication from "@kdpw/msal-b2c-react";

const SidebarMenuList = (props) => {
  const id_token = authentication.getIdToken();
  const Role = id_token.idp;
  const [response, setResponse] = useState("");

  const getToken = () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Bearer " + `${id_token.idp_access_token}`
    );

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      "https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?$count=true",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setResponse(JSON.parse(result).value[0].displayName))
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    if (Role !== undefined) {
      getToken();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const rol = () => {
    if (response === "admin_micrositio") {
      return "ADMINISTRATOR";
    }
    if (response === "vendedor_micrositio") {
      return "VENDEDOR";
    }
    if (response === "Back Office") {
      return "BACKOFFICE";
    }
    return "USER";
  };

  const { pages, ...rest } = props;
  const paginas = pages.filter((x) => x.rol === rol());

  return (
    <List className="p-0">
      {paginas.reduce(
        (items, page) => reduceChildRoutes({ items, page, ...rest }),
        []
      )}
    </List>
  );
};

SidebarMenuList.propTypes = {
  depth: PropTypes.number,
  pages: PropTypes.array,
};

const reduceChildRoutes = (props) => {
  const { router, items, page, depth } = props;

  if (page.content) {
    const open = matchPath(router.location.pathname, {
      path: page.to,
      exact: false,
    });

    items.push(
      <SidebarMenuListItem
        depth={depth}
        icon={page.icon}
        key={page.label}
        label={page.badge}
        open={Boolean(open)}
        title={page.label}
      >
        <div className="sidebar-menu-children py-2">
          <SidebarMenuList
            depth={depth + 1}
            pages={page.content}
            router={router}
          />
        </div>
      </SidebarMenuListItem>
    );
  } else {
    items.push(
      <SidebarMenuListItem
        depth={depth}
        href={page.to}
        icon={page.icon}
        key={page.label}
        label={page.badge}
        title={page.label}
      />
    );
  }

  return items;
};

const SidebarMenu = (props) => {
  const { title, pages, className, component: Component, ...rest } = props;

  const router = useRouter();

  return (
    <Component {...rest} className={className}>
      {title && (
        <Typography className="app-sidebar-heading">{title}</Typography>
      )}
      <SidebarMenuList depth={0} pages={pages} router={router} />
    </Component>
  );
};

SidebarMenu.propTypes = {
  className: PropTypes.string,
  component: PropTypes.any,
  pages: PropTypes.array.isRequired,
  title: PropTypes.string,
};

SidebarMenu.defaultProps = {
  component: "nav",
};

export default SidebarMenu;
